module.exports = __webpack_public_path__ + "static/media/gmdm.004878ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/Assets/fr/gmdm.png
// module id = 132
// module chunks = 0